import { z } from 'my-zod'

export const corporateFleetDispositionStatusEnum = z.enum([
  'Exported',
  'Scrapped',
  'Sold',
  'Donated',
  'Lost-Stolen',
  'Contract',
  'Sweepstakes'
])
export const corporateFleetDispositionStatuses = corporateFleetDispositionStatusEnum.Values

export const corporateFleetDispositionStatusOptions = Object.values(corporateFleetDispositionStatuses)
export type corporateFleetDispositionStatusEnum = z.infer<typeof corporateFleetDispositionStatusEnum>
